<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.BOOKMAKER.REQUEST_BOOKMAKER_ID_CHANGE"
    :handler="() => $refs.modal.show()"
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.BOOKMAKER.REQUEST_ACCOUNT_CONFIRMATION"
    :handler="() => $refs.modal.hide()"
  />
  <DialogComponent ref="modal" type="bottomsheet">
    <div class="p-6">
      <h2 class="text-lg font-bold text-gray-900 mb-6">
        Entrez votre ID {{ $stores.bookmaker?.state?.bookmakerIdSetting?.bookmakerName }}
      </h2>

      <div class="mb-6">
        <ImgComponent
          :src="
            $stores.bookmaker?.state?.bookmakerIdSetting
              ?.bookmakerIdPageScreenshot
          "
          class="w-full h-48 object-cover object-top rounded-xl border border-gray-200"
          alt=""
        />
      </div>

      <form
        @submit.prevent="
          $bus.emit($constants.EVENTS.BOOKMAKER.REQUEST_ACCOUNT_CONFIRMATION, {
            bookmakerId:
              $stores.bookmaker?.state?.bookmakerIdSetting?.bookmakerId,
            bookmaker: $stores.bookmaker?.state?.bookmakerIdSetting?.bookmaker
          })
        "
        class="space-y-4"
      >
        <div class="relative">
          <input
            v-model="$stores.bookmaker.state.bookmakerIdSetting.bookmakerId"
            type="text"
            required
            placeholder=" "
            :id="'bookmakerId-' + $id"
            class="peer inputComponent"
          />
          <label
            :for="'bookmakerId-' + $id"
            class="absolute left-4 top-4 text-gray-400 transition-all peer-focus:-top-2.5 peer-focus:left-3 peer-focus:text-xs peer-focus:text-primary peer-placeholder-shown:top-4 peer-placeholder-shown:left-4 peer-placeholder-shown:text-base peer-not-placeholder-shown:-top-2.5 peer-not-placeholder-shown:left-3 peer-not-placeholder-shown:text-xs peer-not-placeholder-shown:text-primary bg-white px-1 pointer-events-none"
          >
            Votre ID {{ $stores.bookmaker?.state?.bookmakerIdSetting?.bookmakerName }}
          </label>
        </div>

        <div class="flex gap-3 pt-2">
          <button
            type="button"
            class="flex-1 py-4 border border-gray-200 text-gray-700 rounded-xl font-semibold hover:bg-gray-50 transition-all"
            @click="() => $refs.modal.hide()"
          >
            Annuler
          </button>

          <button type="submit" class="flex-1 py-4 bg-primary text-white rounded-xl font-semibold shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all">
            Continuer
          </button>
        </div>
      </form>
    </div>
  </DialogComponent>
</template>

<script setup>
import { getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();
const { $id } = proxy;
</script>
